<template>
  <div>
    <!-- Evaluations Made -->
    <div class="row">
      <div class="col-4 title">
        <div class="tag-badge-info mt-2 mb-0">
          <span class="tag-badge-title-info pb-2 pl-3">
            Evaluaciones Realizadas
          </span>
        </div>
      </div>
      <!-- Evaluations Made buttoms -->
      <div class="col-8">
        <div class="row text-right">
          <div class="col12 position-right">
            <div class="row">
              <div class="col4 float-right mr-3">
                <ActionButton
                  v-if="isDraft && canEdit && canDiscussEvaluation"
                  variant="dark"
                  type="button"
                  i="fas fa-file-alt"
                  @click="goToEvaluationDiscussion"
                >
                  Discusión de Evaluaciones
                </ActionButton>
              </div>
              <div class="col3 float-right">
                <CustomAddRemoveListPopup
                  v-if="showComponentListPopUp && isDraft && canEdit"
                  :object-key="'id'"
                  :object-description="'name'"
                  :initial-show-state="false"
                  btn-classes="btn btn-action btn-green width-adaptive btn-success-softer mr-3 mt-0"
                  :remove-option="true"
                  :added-column-description="'Evaluaciones Seleccionadas'"
                  :removed-column-description="'Evaluaciones Disponibles'"
                  :added-list="selectedEvaluations"
                  :removed-list="availableEvaluations"
                  :disabled-predicate="evaluationsPredicateDisabled"
                  @updated="handleEvaluationsUpdated"
                >
                  <!-- This slot is the content rendered inside the button-->
                  <slot>
                    <i class="fas fa-file-plus pr-2" />
                    <span>Seleccionar Evaluación</span>
                  </slot>
                </CustomAddRemoveListPopup>
              </div>
              <div class="col2 float-right mr-3">
                <ActionButton
                  v-if="canEdit && isDraft"
                  id="modal-btn-anadir"
                  variant="success"
                  type="button"
                  i="fas fa-file-plus"
                  @click="gotToAddEvaluations"
                >
                  A&ntilde;adir
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />

    <div class="container-table-striped">
      <div class="table-responsive">
        <table class="table content-table-striped table-hover table-h">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-4 pl-5 py-3">
                <span class="ml-5 bold">Evaluación</span>
              </th>
              <th class="col-2 py-3 bold">
                Fecha
              </th>
              <th class="col-4 py-3 bold">
                Administrada por
              </th>
              <th class="col-2 pl-5 py-3" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in generalEvaluations"
              :key="item.studentEvaluationId + item.peiId"
              class="row"
            >
              <td class="col-4 td-aligned">
                <div class="ml-5 disciplineName-text">
                  {{ item.disciplineName }}
                </div>
              </td>
              <td class="col-2 td-aligned">
                {{ formatDate(item.evaluationDate) }}
              </td>
              <td class="col-4 td-aligned">
                {{ item.evaluationAdministeredBy }}
              </td>
              <td class="col-2 dropdown py-3 pr-5 text-right">
                <button
                 v-if="item.peiStatusCode == isDraft && canEdit"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu pb-0 dropdown-menu-right">
                  <a
                    v-if="item.peiStatusCode == isDraft && canEdit"
                    class="drop-item cursor-pointer"
                    @click="
                      deleteEvaluation(item.studentEvaluationId, item.peiId)
                    "
                  >
                    <i class="fas fa-times-circle text-red pr-1" />
                    <span>Eliminar</span>
                  </a>
                  <a
                    class="drop-item cursor-pointer"
                    href="#"
                    data-toggle="modal"
                    data-target="#modalEval"
                    @click="getHistoryEvaluations(item.disciplineTypeId)"
                  >
                    <i class="fas fa-history text-green pr-1" />
                    <span>Historial de Evaluación</span>
                  </a>

                  <div class="dropdown-divider" />
                  <h5 class="dropdown-item">
                    <span>Documentos</span>
                  </h5>

                  <a
                    class="drop-item cursor-pointer bg-light-gray"
                    href="#"
                    @click="downloadDocumentEvaluation($event, item)"
                  >
                    <i class="fas fa-file-alt text-green pr-1" />
                    <span>Evaluaciones</span>
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="hasResultSummary" class="row">
              <td class="col-4 td-aligned">
                <div class="ml-5 disciplineName-text">
                  Resumen de Resultados
                </div>
              </td>
              <td class="col-2 td-aligned">
                -
              </td>
              <td class="col-4 td-aligned">
                -
              </td>
              <td class="col-2 dropdown py-3 pr-5 text-right">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a
                    class="drop-item cursor-pointer"
                    @click="downloadResultSummary"
                  >
                    <i class="fas fa-file-search text-green pr-2" />
                    <span>Ver Documento</span>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Error
      v-if="ValidationTriggered.validation && invalidEvaluations[0]"
      :message="resources[2001]"
      class="no-border"
    />
    <div v-for="item in tabValidation" :key="item.id">
      <Error :message="item.name" class="no-border" />
    </div>

    <!-- Modal -->
    <HistoryPopup
      id="modalEval"
      title="Historial de Evaluación"
      icon-title="fas fa-save"
      column-one-name="evaluationDate"
      column-one-title="Fecha"
      :column-one-format-fn="formatDate"
      column-two-name="evaluationAdministeredBy"
      column-two-title="Administrada Por"
      :items="currentHistoryEvaluation"
    >
      <div slot="sub-title">
        <strong>Evaluación:</strong>
        <span v-if="currentHistoryEvaluation">{{ titleDisciplineName }}</span>
      </div>
    </HistoryPopup>
  </div>
</template>

<script>
import peiStatuses from "@/utils/constants/pei/peiStatus.js";
import toastTypes from "@/utils/constants/toastTypes.js";

import store from "@/store/index";
import moment from "moment";
import alert from "@/mixin/alert.mixin";
import CustomAddRemoveListPopup from "@/components/common/CustomAddRemoveListPopup";
import { HistoryPopup } from "@/components/pei/shared";
import generalService from "@/services/pei/general";
import Error from "@/components/common/Error";
import resourcesService from "@/services/resources.js";
import ActionButton from "@/components/common/ActionButton";

import disciplineTypes from "@/utils/constants/disciplineTypes.js";
import documentCategory from "@/utils/constants/documentCategory.js";
import general from "@/services/pei/general";
import resultSummaryReportTypes from "@/utils/constants/pei/resultSummaryReportTypes";

export default {
  name: "EvalDiscussionPei",
  props: {
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      peiStatus: store.getters.SelectedPeiStatus,
      disciplineTypes: disciplineTypes,
      generalEvaluations: [],
      currentHistoryEvaluation: [],
      titleDisciplineName: "",
      availableEvaluations: [],
      selectedEvaluations: [],
      showComponentListPopUp: true,
      isPrescholar: store.getters.getPeiInfo.prescholarFlag == "1",
      resources: []
    };
  },
  components: {
    CustomAddRemoveListPopup,
    HistoryPopup,
    Error,
    ActionButton
  },
  mixins: [alert],
  methods: {
    async getGeneralEvaluations() {
      let self = this;
      await self
        .$ApiGet(`api/pei/generalevaluations/${store.getters.SelectedPei}`)
        .then(function(response) {
          self.generalEvaluations = response.data;
        })
        .catch(function(error) {
          self.showErrorMessage(error);
        });
    },
    async getHistoryEvaluations(disciplineTypeId) {
      let self = this;
      await self
        .$ApiGet(
          `api/pei/evaluationhistory/${store.getters.SelectedStudent.studentId}/${disciplineTypeId}`
        )
        .then(function(response) {
          self.currentHistoryEvaluation = response.data;
          self.titleDisciplineName = response.data[0].disciplineName;
        })
        .catch(function(error) {
          self.showErrorMessage(error);
        });
    },
    showErrorMessage(error) {
      if (error && error.response && error.response.data) {
        this.ShowToast("", error.response.data.message, "error");
      } else if (error && error.data) {
        this.ShowToast(
          error.data.message,
          self.resources["R03200108"],
          toastTypes.Error
        );
      }
    },
    async loadEvalData() {
      this.showComponentListPopUp = false;
      let respEvalAvailable = await this.getEvaluationAvailableLists();
      let respEvalSelected = await this.getEvaluationSelectedLists();

      let respEvalAvailableWithDisableList = this.getEvaluationWithDisabledList(
        respEvalAvailable,
        respEvalSelected
      );

      this.availableEvaluations = respEvalAvailableWithDisableList;
      this.selectedEvaluations = respEvalSelected;
      this.showComponentListPopUp = true;
    },
    hideEvaluation(studentEvaluationId) {
      const generalEvaluations = this.generalEvaluations.filter(
        g => g.studentEvaluationId !== studentEvaluationId
      );
      this.generalEvaluations = generalEvaluations;
    },
    async deleteEvaluation(studentEvaluationId, peiId) {
      let academicYear = store.state.pei.academicYear;
      const optionChosen = await this.ShowCancelModal(
        "Alerta",
        `¿Está seguro que desea eliminar la evaluación del PEI o PS ${academicYear}?`,
        "Sí",
        "No"
      );
      if (optionChosen) {
        let self = this;
        await self
          .$ApiPost(`api/pei/deleteevaluation`, {
            StudentEvaluationId: studentEvaluationId.toString(),
            PeiId: peiId
          })
          .then(async function() {
            await self.loadEvalData();
          })
          .then(function() {
            self.hideEvaluation(studentEvaluationId);
            self.ShowToast(
              self.resources["R03200110"],
              "Los datos fueron removidos del PEI exitosamente.",
              toastTypes.Success
            );
          })
          .catch(function(error) {
            self.showErrorMessage(error);
          });
      }
    },
    async getListOfDocumentForDownload(studentEvaluationId) {
      let self = this;
      const studentSieId = store.getters.SelectedStudent.studentId;
      await self
        .$ApiGet(
          `api/studentevaluation/${studentSieId}/documents/${studentEvaluationId}`
        )
        .then(function(resp) {
          return resp;
        })
        .catch(function(error) {
          self.showErrorMessage(error);
          return [];
        });
    },
    async getEvaluationAvailableLists() {
      let self = this;
      let data = [];
      await self
        .$ApiGet(
          `api/pei/${store.getters.SelectedStudent.studentId}/availablesevaluations/${store.getters.SelectedPei}`
        )
        .then(function(response) {
          data = response.data;
        })
        .catch(function(error) {
          self.showErrorMessage(error);
          return;
        });

      return data;
    },
    async getEvaluationSelectedLists() {
      let self = this;
      let data = [];
      await self
        .$ApiGet(`api/pei/getselectedevaluation/${store.getters.SelectedPei}`)
        .then(function(response) {
          data = response.data;
        })
        .catch(function(error) {
          self.showErrorMessage(error);
          return;
        });

      return data;
    },
    getEvaluationWithDisabledList(availableList, selectedList) {
      let returnedList = availableList;

      for (let item of selectedList) {
        let index = "-1";
        for (let indice in availableList) {
          if (availableList[indice].id == item.id) {
            index = indice;
            break;
          }
        }

        if (index != "-1") {
          returnedList[index].disabled = true;
        }
      }

      return returnedList;
    },
    evaluationsPredicateDisabled(evaluation) {
      return evaluation.disabled;
    },
    async downloadDocumentEvaluation(event, evaluation) {
      event.preventDefault();

      if (
        !evaluation.studentEvaluationId ||
        !evaluation.studentEvaluationsDocumentIds
      ) {
        this.ShowToast(
          this.resources["R900001"],
          this.resources["R03200150"],
          toastTypes.Error
        );
      }
      let finalNoResponse = true;
      let documents = evaluation.studentEvaluationsDocumentIds.split(",");

      for (let i = 0; documents[i]; i++) {
        let response = await generalService.downloadDocumentByAttachmentIdByDocumentCategory(
          documents[i],
          documentCategory.StudentEvaluationDocument
        );
        if (!response) {
          finalNoResponse = false;
        }
      }
      if (finalNoResponse) {
        this.ShowToast(
          this.resources["R900001"],
          this.resources["R03200150"],
          toastTypes.Error
        );
      }
    },
    async handleEvaluationsUpdated(selectedEvalList) {
      this.showComponentListPopUp = false;

      let peiId = store.getters.SelectedPei;
      let self = this;

      await self
        .$ApiPost(`api/pei/updatepeievaluation`, {
          PeiId: peiId,
          SelectedItems: selectedEvalList
        })
        .then(function(response) {
          if (response.data) {
            self
              .$ApiGet(`api/pei/generalevaluations/${peiId}`)
              .then(function(response) {
                self.generalEvaluations = response.data;
              })
              .catch(function(error) {
                self.showErrorMessage(error);
              });
          }
        })
        .then(async function() {
          await self.loadEvalData();
        })
        .catch(function(error) {
          self.showErrorMessage(error);
          return;
        });

      this.showComponentListPopUp = true;
    },
    formatDate(value) {
      if (value) {
        return moment(value)
          .locale("es-PR")
          .format("DD/MMM/YYYY");
      }
    },
    goToEvaluationDiscussion() {
      const studentSieId = store.getters.SelectedStudent.studentId;
      let path = `/student/evaluationdiscuss/${studentSieId}`;
      this.$router.push(path);
    },
    gotToAddEvaluations() {
      const self = this;
      self.$router.push({
        name: "student-evaluation-history-add",
        params: {
          from: "Regresar a la parte II del PEI",
          headerTitle: "Estudiante: Proceso de Evaluación Trianual",
          toward: {
            name: "peiDetail",
            query: { tab: "Tab2" }
          }
        }
      });
    },
    async loadResources() {
      let resourceCodes = [
        "2001",
        "2002",
        "R900001",
        "R03200108",
        "R03200110",
        "R03200109",
        "R03200150"
      ];
      this.resources = await resourcesService.LoadResources(resourceCodes);
    },
    async downloadResultSummary() {
      if (!this.hasResultSummary) return;

      this.resultSummaryAnalysisServiceIds.forEach(async id => {
        let report = `referral/downloadresultsummariesbytype/${id}/${resultSummaryReportTypes.resultSummary}`;
        await general.downloadReport(report);
      });
    }
  },
  computed: {
    invalidEvaluations() {
      let evaluationErrors = [false, false];
      if (this.ValidationTriggered) {
        if (!this.generalEvaluations) {
          evaluationErrors = [true, true];
        } else {
          if (
            this.generalEvaluations.findIndex(
              x =>
                x.disciplineTypeId ==
                this.disciplineTypes.HISTORIAL_DEL_DESARROLLO
            ) < 0
          ) {
            evaluationErrors[0] = true;
          }
          if (
            !this.isPrescholar &&
            this.generalEvaluations.findIndex(
              y => y.disciplineTypeId == this.disciplineTypes.INFORME_ACADEMICO
            ) < 0
          ) {
            evaluationErrors[1] = true;
          }
        }
      }
      return evaluationErrors;
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },

    tabValidation() {
      if (!this.ValidationTriggered.tabValidation) {
        return [];
      }

      return this.ValidationTriggered.tabValidation.find(x => x.id == "Tab2")
        .errors;
    },
    isDraft() {
      const self = this;

      const isdraft = self.peiStatus == peiStatuses.Borrador;
      return isdraft;
    },
    canDiscussEvaluation() {
      return store.getters.HasPermission("pei.evaluationdiscution");
    },
    userPilotPlan() {
      return store.getters["$_user/pilotPlan"];
    },
    hasResultSummary() {
      return store.getters.getPeiTab2Information?.hasResultSummary;
    },
    resultSummaryAnalysisServiceIds() {
      return store.getters.getPeiTab2Information
        ?.resultSummaryAnalysisServiceIds;
    }
  },
  async mounted() {
    await this.loadResources();
    await this.getGeneralEvaluations();
    await this.loadEvalData();
  }
};
</script>

<style scoped>
/* Referral for Technology Assistance Services*/
.row {
  margin-left: 0px;
  margin-right: 0px;
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.thead-table-modal {
  border-radius: 5px 5px 0px 0px !important;
  display: table-caption;
}
.td-aligned {
  padding-right: 0px;
  padding-left: 32px;
}
.content-table-striped-modal {
  margin-top: 0px;
}
.title {
  padding-left: 0px;
}
.btn-space1 {
  margin-top: -81px;
  margin-right: 5px;
}
.btn-space {
  margin-top: -60px;
  margin-right: -10px;
}
.btn-action {
  font-weight: 500;
  font-size: 0.9rem;
}
.textarea-edge {
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}
.table-h {
  height: 480px;
}
.bg-dark {
  border-collapse: collapse;
  background-color: #3f5b60 !important;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  color: #ffffff;
  font-weight: 400;
}
.tdDate {
  width: 33.5%;
}
.textNorm {
  font-weight: 400;
}
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
.btn-info-darker {
  border-bottom-width: 2px;
  margin-bottom: 0px;
  padding-bottom: 3px;
  padding-top: 4px;
}
.btn-success-softer {
  padding-bottom: 1px;
  padding-top: 2px;
  margin-bottom: 2px;
  margin-top: 2px !important;
}
.dropdown-item {
  font: Bold 16px/19px Lato;
}
.disciplineName-text {
  word-break: break-word;
}
.position-right {
  position: absolute;
  right: 0px;
}
@media (min-width: 992px) {
  .btn-dropdown-actions {
    width: 4.5rem;
    font-size: 0.7rem;
    margin-right: 0px;
  }
}
@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
    margin-right: -8px;
  }
}
@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 7.4375rem;
  }
}
@media only screen and (max-width: 1300px) and (min-width: 600px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
  }
}
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}
.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}
.orange-icon-badge-align {
  vertical-align: top;
}
.tag-badge-title {
  text-align: left;
  font: Bold 17px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}
.close-ico {
  color: #2db782;
  margin-right: 3px;
}
.modal-header {
  padding: 0.5rem 0rem 0rem 1.5rem;
  box-shadow: 0px 10px 40px -20px black;
}
.cursor-pointer {
  cursor: pointer;
}
/* Referral for Technology Assistance Services*/
</style>
